import React, { useEffect, useState } from 'react';

import closeIcon from '../../../../assets/icons/close.svg';
import search_icon from '../../../../assets/icons/search.svg';
import { getCategories } from '../../../../api/getCategories';
import { useTranslation } from 'react-i18next';
import { t } from 'i18next';

const getCategoryName = (category, language) => {
    switch (language) {
        case 'en':
            return category.eng_name;
        case 'kz':
            return category.kz_name;
        case 'cn':
            return category.ch_name;
        default:
            return category.name;
    }
};

const getSubcategoryName = (subcategory, language) => {
    switch (language) {
        case 'en':
            return subcategory.eng_name;
        case 'kz':
            return subcategory.kz_name;
        case 'cn':
            return subcategory.ch_name;
        default:
            return subcategory.name;
    }
};

const CategoryModal = ({ onSelect, onClose, initialSelectedCategoryId, initialSelectedSubcategoryId }) => {
    const [categories, setCategories] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const [selectedCategoryId, setSelectedCategoryId] = useState(initialSelectedCategoryId);
    const [selectedSubcategoryId, setSelectedSubcategoryId] = useState(initialSelectedSubcategoryId);

    const { i18n } = useTranslation();

    useEffect(() => {
        async function fetchCategories() {
            try {
                const categoriesData = await getCategories();
                setCategories(categoriesData);
            } catch (error) {
                console.error("Failed to load categories:", error);
            }
        }

        fetchCategories();
    }, []);

    const handleCategoryClick = (category) => {
        const newCategoryId = selectedCategoryId === category.id ? null : category.id;
        setSelectedCategoryId(newCategoryId);
    };

    const handleSubcategoryClick = (category, subcategory) => {
        setSelectedCategoryId(category.id);
        setSelectedSubcategoryId(subcategory.id);

        localStorage.setItem("selectedCategoryName", getCategoryName(category, i18n.language));
        localStorage.setItem("selectedSubcategoryName", getSubcategoryName(subcategory, i18n.language));

        localStorage.setItem("selectedCategoryId", category.id);
        localStorage.setItem("selectedSubcategoryId", subcategory.id);

        if (onSelect) {
            onSelect({ category, subcategory });
        }
        onClose();
    };

    const filteredCategories = categories.filter(category =>
        getCategoryName(category, i18n.language).toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="h-full w-full bg-[var(--secondary-color)] md:bg-[var(--background-white-color)] flex flex-col p-4 md:p-5">
            <div className="flex items-center justify-between mb-3 relative">
                <h2 className="text-xl font-bold text-[var(--text-color)]">{t('categories')}</h2>
                <button
                    className="click flex absolute right-0 top-0 bg-[var(--primary-color)] text-white rounded-full w-[36px] h-[36px] md:w-[40px] md:h-[40px] items-center justify-center border-none hover:bg-[var(--hover-color)]"
                    onClick={onClose}
                    type="button"
                >
                    <img src={closeIcon} alt="Close" className="w-5 h-5" />
                </button>
            </div>
            <div className="mb-4">
                <div className="relative">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2">
                        <img
                            className="w-5 h-5 opacity-70"
                            src={search_icon}
                            alt={t('search')}
                        />
                    </span>
                    <input
                        className="w-full pl-10 pr-3 py-2 rounded-[10px] border border-[#ddd] bg-white text-sm outline-none focus:ring-2 focus:ring-[var(--primary-color)] focus:border-[var(--primary-color)]"
                        placeholder={t('search')}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            <div className="flex flex-col gap-3 overflow-y-auto h-[80%] pb-4 pr-1">
                {filteredCategories.map((category) => (
                    <div key={category.id}>
                        <div className="click flex items-center gap-3 bg-[var(--background-white-color)] rounded-[10px] cursor-pointer overflow-hidden">
                            <img
                                className="w-[110px] h-[110px] rounded-l-[10px] object-cover"
                                src={category.image_url}
                                alt={getCategoryName(category, i18n.language)}
                                onClick={() => handleCategoryClick(category)}
                            />
                            <div
                                className="font-semibold text-base"
                                onClick={() => handleCategoryClick(category)}
                            >
                                {getCategoryName(category, i18n.language)}
                            </div>
                        </div>
                        {selectedCategoryId === category.id && category.subcategories && (
                            <div className="flex flex-wrap gap-3 mt-2 md:grid md:grid-cols-2 md:gap-2">
                                {category.subcategories.map((sub) => (
                                    <div
                                        key={sub.id}
                                        className={`text-[var(--primary-color)] cursor-pointer text-sm flex items-center justify-center px-3 py-1.5 rounded-[10px] ${
                                            selectedSubcategoryId === sub.id
                                                ? "bg-[var(--primary-color)] text-white font-medium"
                                                : ""
                                        }`}
                                        onClick={() => handleSubcategoryClick(category, sub)}
                                    >
                                        {getSubcategoryName(sub, i18n.language)}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CategoryModal;